/* EasyHemo V4.2: direct Shopify checkout per selected one-time pack. Native form is retained only as progressive-enhancement fallback. */
(() => {
  const formatter = (iso) => new Intl.NumberFormat('en-US', { style: 'currency', currency: iso || 'USD' });
  function init(root) {
    if (!root || root.dataset.eh4Init === 'yes') return;
    root.dataset.eh4Init = 'yes';
    const optionInputs = Array.from(root.querySelectorAll('[data-eh4-option]'));
    const idField = root.querySelector('[data-eh4-variant]');
    const total = root.querySelector('[data-eh4-total]');
    const submit = root.querySelector('[data-eh4-submit]');
    const submitText = root.querySelector('[data-eh4-submit-text]');
    const recap = root.querySelector('[data-eh4-recap]');
    const productForm = root.querySelector('form.eh4-form');
    // V4.5: real, finger-following horizontal scroll with CSS scroll-snap.
    // The browser handles the drag; JS only updates navigation and counter.
    const gallery = root.querySelector('[data-eh4-swipe]');
    const slides = Array.from(root.querySelectorAll('[data-eh4-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-eh4-thumb]'));
    const count = root.querySelector('[data-eh4-count]');
    let currentIndex = 0;
    const money = formatter(root.dataset.currency || 'USD');

    function paintGalleryIndex(index) {
      currentIndex = Math.max(0, Math.min(slides.length - 1, index));
      thumbs.forEach((item, i) => {
        const active = i === currentIndex;
        item.classList.toggle('is-current', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (count) count.textContent = `${String(currentIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    }

    function chooseImage(index) {
      if (!gallery || !slides.length) return;
      const target = (index + slides.length) % slides.length;
      paintGalleryIndex(target);
      gallery.scrollTo({
        left: target * gallery.clientWidth,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    // Follow real native swipe scroll, including partial movements during the drag.
    if (gallery && slides.length) {
      let pending = false;
      gallery.addEventListener('scroll', () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          const width = gallery.clientWidth || 1;
          const index = Math.round(gallery.scrollLeft / width);
          if (index !== currentIndex) paintGalleryIndex(index);
        });
      }, { passive: true });
      gallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          chooseImage(currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    }
    function updateVariant() {
      const selected = optionInputs.find((opt) => opt.checked);
      if (!selected || !idField) return;
      idField.value = selected.dataset.id;
      if (total) total.textContent = money.format(Number(selected.dataset.cents) / 100);
      const available = selected.dataset.available === 'true';
      if (submit) submit.disabled = !available;
      if (submitText) submitText.textContent = available ? 'START MY TREATMENT' : 'SOLD OUT';
      const packCount = Number(selected.dataset.packCount) || 1;
      const discount = Number(selected.dataset.discountPct) || 0;
      if (recap) {
        const days = packCount * 7;
        recap.textContent = `${days}-day supply · ${discount ? `Save ${discount}% vs. single tubes · ` : ''}No recurring charges`;
      }
    }
    optionInputs.forEach((input) => input.addEventListener('change', () => {
      updateVariant();
      // Gallery remains the same four 4:5 images for every pack size.
    }));
    // Use documented Shopify cart permalink: /cart/{numeric_variant_id}:1.
    // This creates a checkout containing exactly the chosen bundle, not the old drawer contents.
    // Keep the original form as fallback when JS is unavailable.
    if (submit && productForm) {
      submit.type = 'button'; // prevents the Beauty theme's AJAX cart-drawer handler
      submit.addEventListener('click', () => {
        const selected = optionInputs.find((opt) => opt.checked);
        const id = selected?.dataset.id || '';
        if (!selected || selected.dataset.available !== 'true' || !/^\d+$/.test(id)) return;
        submit.disabled = true;
        if (submitText) submitText.textContent = 'OPENING CHECKOUT...';
        const rootPath = root.dataset.eh4CheckoutRoot || '/';
        const path = (rootPath.endsWith('/') ? rootPath : rootPath + '/') + 'cart/' + id + ':1';
        window.location.assign(path);
      });
      // Browser back-forward cache: restore the button if customer comes back.
      window.addEventListener('pageshow', () => { updateVariant(); });
    }

    thumbs.forEach((item) => item.addEventListener('click', () => chooseImage(thumbs.indexOf(item))));
    root.querySelector('[data-eh4-prev]')?.addEventListener('click', () => chooseImage(currentIndex - 1));
    root.querySelector('[data-eh4-next]')?.addEventListener('click', () => chooseImage(currentIndex + 1));
    updateVariant();
  }
  function initAll() { document.querySelectorAll('[data-eh4-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true }); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
